import { FC } from 'react'
import Select from '../../../control/select/select'
import MultiSelect from '../../../control/multiSelect/multiSelect'
import { Grid, Paper, Typography } from '@material-ui/core'
import Button from '../../../control/button/button'
import { Form } from 'react-final-form'
import { makeStyles } from '@material-ui/core/styles'

import useTranslate from '../../../i18n/useTranslate'
import useProjectStatus from '../../../services/um/lookups/useProjectStatus'
import useIRB from '../../../services/um/lookups/useIRB'
import { KeywordType } from '../../../services/um/useSearchSettingConsideration'

interface PanelProps {
    onSubmit: (values: KeywordType) => void
    initialSearch: any
    onReset: (form: any) => void
}

const Panel: FC<PanelProps> = ({ initialSearch, onSubmit, onReset }) => {
    const translate = useTranslate()
    const classes = useStyles()
    const { projectStatus } = useProjectStatus()
    const { irb } = useIRB()
    const defaultSelect = initialSearch.recID ? [initialSearch.recID] : undefined
    const defaultMultiselect = initialSearch.submittedTypeID ? [initialSearch.submittedTypeID] : undefined

    return (
        <Form onSubmit={onSubmit} initialValues={initialSearch}>
            {({ handleSubmit, form }) => {
                return (
                    <Grid container className={classes.root} spacing={2}>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Select
                                name="recID"
                                option={irb}
                                label={translate.get('UM.SETTING_CONSIDERATION.REC')}
                                placeholder={translate.get('UM.SETTING_CONSIDERATION.REC')}
                                size="small"
                                defaultValue={defaultSelect}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Select
                                name="submittedTypeID"
                                option={projectStatus}
                                label={translate.get('UM.SETTING_CONSIDERATION.SUBMITTED_TYPE')}
                                placeholder={translate.get('UM.SETTING_CONSIDERATION.SUBMITTED_TYPE')}
                                size="small"
                                defaultValue={defaultMultiselect}
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container justify="flex-end" spacing={2}>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="default"
                                        onClick={() => {
                                            form.reset()
                                            onReset(form)
                                        }}
                                        className={classes.btnSearch}
                                    >
                                        {translate.get('BUTTON.RESET')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        className={classes.btnSearch}
                                    >
                                        {translate.get('BUTTON.SEARCH')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        </Form>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '15px',
    },

    clear: {
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: '0px 1.5rem',
        alignSelf: 'center',
    },
    paperSearch: {
        width: '100%',
        padding: theme.spacing(3),
        marginBottom: '10px',
    },
    btnSearch: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
}))

export default Panel
